export default {
  OWN: "own",
  OTHER_PERSON: "otherPerson",
  OTHER_LEGAL_PERSON: "otherLegalPerson",
  REPAIR_SHOP: "repairShop",
  DONT_KNOW: "dontKnow",
};